import React, { Component } from 'react';
import arrowPointerIcon from "assets/images/icon_arrow_pointer.svg";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from "states/appState";
import "./tab4.scss";
import ReactSVG from 'react-svg';
import * as LocalApi from "_services/LocalApi";

export class View extends Component {

    constructor(props) {
        super(props);

        this.state = {
            fullImageUrl: null
        }

        this.fileHandle = null;
        this.fileRequestId = 0;
        this.unmounted = false;
    }

    componentDidMount() {
        this.getFileURL();
    }

    componentDidUpdate(prevProps) {
        const previousFileId = prevProps.probeImage ? prevProps.probeImage.file_id : 0;
        const currentFileId = this.props.probeImage ? this.props.probeImage.file_id : 0;
        if(previousFileId !== currentFileId ||
            prevProps.appState.currentIncidentId !== this.props.appState.currentIncidentId) {
            this.getFileURL();
        }
    }

    componentWillUnmount() {
        this.unmounted = true;
        this.fileRequestId += 1;
        LocalApi.releaseFile(this.fileHandle);
        this.fileHandle = null;
    }

    replaceFile = fileHandle => {
        LocalApi.releaseFile(this.fileHandle);
        this.fileHandle = fileHandle;
        this.setState({
            fullImageUrl: fileHandle ? fileHandle.url : null
        });
    }

    getFileURL = (props = this.props) => {
        const requestId = ++this.fileRequestId;
        this.replaceFile(null);

        if(!props.probeImage || props.probeImage.file_id === 0) {
            return Promise.resolve(null);
        }

        return LocalApi.getFile(
            props.probeImage.file_id,
            props.appState.currentIncidentId
        ).then((fileHandle) => {
            if(this.unmounted || requestId !== this.fileRequestId) {
                LocalApi.releaseFile(fileHandle);
                return null;
            }

            this.replaceFile(fileHandle);
            return fileHandle;
        });
    }
    
    render = () => {
        let mainImage = null;
        let arrowImage = null;

        if(this.state.fullImageUrl) {
            const arr = this.props.probeImage.arrow;
            const st = {
                'top': arr.y + "px",
                'left': arr.x + "px",
                'transform': "rotate(" + arr.rotation + "deg)",
                width: '50px',
                height: '50px'
            }
            
            mainImage = <img className="img-photo" alt="" src={this.state.fullImageUrl} />;

            if(arr.show) {
                arrowImage = <ReactSVG style={st} alt="" className="img-arr" src={arrowPointerIcon} />;
            }
        } else {
            mainImage = <img alt="" className="no-cam" src={require("assets/images/no_cam.png")} />;
        }

        return (
            <div className="img-proben-img" key={this.props.key} >
                {mainImage}
                {arrowImage}
            </div>
        )
    }
}

export default connect(
    state => state,
    dispatch => ({
        actions: bindActionCreators(actions, dispatch),
    })
)(View);
